import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5169 5.73273C16.8024 6.0183 16.8024 6.48131 16.5169 6.76688L9.01688 14.2669C8.73131 14.5524 8.2683 14.5524 7.98273 14.2669L4.23273 10.5169C3.94716 10.2313 3.94716 9.7683 4.23273 9.48273C4.5183 9.19716 4.98131 9.19716 5.26688 9.48273L8.4998 12.7157L15.4827 5.73273C15.7683 5.44716 16.2313 5.44716 16.5169 5.73273Z"
      fill="currentColor"
    />
  </svg>
);

const TickIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default TickIcon;
